import { useMemo } from 'react';

import type { UsePageInfoProps, UsePageInfoReturnType } from './types.ts';

export const usePageInfo = ({ page, perPage, total }: UsePageInfoProps): UsePageInfoReturnType => {
  const from = page * perPage + 1;
  const to = Math.min(total, (page + 1) * perPage);

  return useMemo<UsePageInfoReturnType>(
    () => ({
      from,
      to,
      total,
    }),
    [from, to, total],
  );
};
